module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/compass.svg?98004db51db25e5522b2fd197c0e9a6e";